export const RADIAL_CHART_STYLE = {
  'chart-hint': {
    background: 'rgba(137, 170, 181, 0.9)',
    color: 'black',
    borderRadius: '3px',
    padding: '5px',
    boxShadow: '0px 5px 10px 1px rgba(10, 10, 10, 0.4)',
    textAlign: 'center',
    stroke: 'white !important',
    strokeWidth: '2px'
  },
  'highlight-arc': {
    stroke: 'black !important',
    strokeWidth: '2px'
  },
  'arc': {
    stroke: '#fafafa !important',
    strokeWidth: '2px'
  }
}

export const HEATMAP_CHART_STYLE = {
  'chart-hint': {
    background: 'rgba(137, 170, 181, 0.9)',
    color: 'black',
    borderRadius: '3px',
    padding: '5px',
    boxShadow: '0px 5px 10px 1px rgba(10, 10, 10, 0.4)',
    textAlign: 'center',
    stroke: 'white !important',
    strokeWidth: '2px'
  }
}



// WEBPACK FOOTER //
// ./src/constants/classes.js